import React, { useState, useRef } from 'react';
import "./Rightpart.css";
// import "./OrderRight";
import profile from "../assets/images/profile.png"; 
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function SupportRight() {
  const [profileImg, setProfileImg] = useState(profile); 
  const fileInputRef = useRef(null);

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImg(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <div className='outer-div-right'>
       <div className='dashbord-right-section'>
         <div className='dashbord-header'>
            <p className='title-dash'>Support</p>
            
           <div className='dropdown-section d-flex align-items-center'>
            <div className="dropdown">
              <button className="btn dropdown-toggle d-flex align-items-center gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                <div className='profile-name'>
                  <img src={profile} alt="" />
                  <div className='name-mail'>
                    <h4>DEEPAK SHARMA</h4>
                    <p>Deepak@gmail.com</p>
                  </div>
                </div>
                <ExpandMoreIcon /> 
              </button>

              <ul className="dropdown-menu ">
                <li><a className="dropdown-item" href="#">Profile</a></li>
                <li><a className="dropdown-item" href="#">Support</a></li>
                <li><a className="dropdown-item" href="#">Logout</a></li>
              </ul>
            </div>
          </div>
         </div>


         <div className='content-dashborad-outer'>
              <div className='row'>
               <div className='col-lg-12'>
                <div className='supot-form-box'>
                  <div className='box-top'>
                   <div className='sr-number'>
                      <h4>Create Ticket</h4>
                    </div>
                 </div>
                  <div className='billing-text ticket-form'>
                      <form className="ticket-form">
                      <div className="form-row">
                        <div className="form-box">
                          <span className="label">Select Request Type</span>
                          <select>
                            <option>Order Issue</option>
                            <option>Payment Issue</option>
                          </select>
                        </div>
                        <div className="form-box">
                          <span className="label">Comment</span>
                          <textarea placeholder=""></textarea>
                        </div>
                      </div>
                      <button className="ticket-submit-btn submit-btn">Submit Ticket</button>
                    </form>
                  </div>
                </div>
               </div>

                <div className='col-lg-8 col-12'>
                 <div className='support-hsty'>
                   <div className='box-top'>
                    <div className='sr-number'>
                        <h4>Latest Support History</h4>
                      </div>
                    </div>
                    <div className='billing-text ticket-data table-responsive'>
                      <table className="ticket-table">
                          <tbody>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>25/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status inprocess">
                                <p>Inprocess</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>12/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status approve">
                                <p>Approve</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>12/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status submit">
                                <p>Approve</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                            <tr>
                              <td>
                                <p>SR#136364726</p>
                                <span>Support Req No</span>
                              </td>

                              <td>
                                <p>Refund Request</p>
                                <span>Request Type</span>
                              </td>

                              <td>
                                <p>12/04/2026</p>
                                <span>Date</span>
                              </td>

                              <td className="status cancel">
                                <p>Approve</p>
                                <span>Support Status</span>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                    </div>
                 </div>
               </div>

               <div className='col-lg-4 col-12'>
                 <div className='faq-dashbrd'>
                   <div className='box-top'>
                    <div className='sr-number'>
                        <h4>FAQS</h4>
                      </div>
                    </div>
                 </div>
                 <div className='billing-text faq-main'>

                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          What materials are used?
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                         Are your products eco-friendly?
                        </button>
                      </h2>
                      <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Do you offer customization?
                        </button>
                      </h2>
                      <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour">
                         How do I care for the textiles?
                        </button>
                      </h2>
                      <div id="collapsefour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive">
                          Do you provide home delivery?
                        </button>
                      </h2>
                      <div id="collapsefive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We use premium-quality fabrics like cotton, silk, and blends.
                        </div>
                      </div>
                    </div>
                  </div>
                  
                 </div>
               </div>
             </div>
         </div>
       </div>
    </div>
  )
}







// import React from "react";
// import "./Rightpart.css";
// import profile from "../assets/images/profile.png";
// import deshboardimg from "../assets/images/deshboard-img.png";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

// export default function SupportRight() {
//   return (
//     <div className="outer-div-right">
//       <div className="dashbord-right-section">
//         <div className="dashbord-header">
//           <p className="title-dash">Support</p>
//           <div className="profile-name">
//             <img src={profile} alt="" />
//             <div className="name-mail">
//               <h4>DEEPAK SHARMA</h4>
//               <p>Deepak@gmail.com</p>
//             </div>
//           </div>
//         </div>
//         <div className="content-dashborad-outer">
          
//           <div className="table-dashbord">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Order ID</th>
//                   <th>Order Status</th>
//                   <th>Date</th>
//                   <th>Number of Product</th>
//                   <th>Amount</th>
//                   <th>View</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status placed">Placed</span>
//                   </td>
//                   <td>17-04-2026</td>
//                   <td>2</td>
//                   <td>30,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status dispatch">Dispatch</span>
//                   </td>
//                   <td>15-04-2026</td>
//                   <td>1</td>
//                   <td>10,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status packed">Packed</span>
//                   </td>
//                   <td>12-04-2026</td>
//                   <td>3</td>
//                   <td>5,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#123</td>
//                   <td>
//                     <span className="status delivered">Delivered</span>
//                   </td>
//                   <td>18-04-2026</td>
//                   <td>5</td>
//                   <td>60,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td>Neworder#1236</td>
//                   <td>
//                     <span className="status pending">Pending</span>
//                   </td>
//                   <td>1-04-2026</td>
//                   <td>8</td>
//                   <td>70,000/-</td>
//                   <td>
//                     <VisibilityOutlinedIcon />
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
